import { Alert } from '@insights-ltd/design-library/components';
import { Trans } from 'react-i18next';
import { Box, styled } from '@mui/material';

const StyledSpan = styled('span')(({ theme }) => ({
  cursor: 'pointer',
  userSelect: 'none',
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.primary.main,
}));

const LearnerSearchMessage = ({
  onClick,
  i18nKey,
}: {
  onClick: () => void;
  i18nKey: string;
}) => {
  return (
    <Box
      data-testid="learners-search-message"
      sx={() => ({
        maxWidth: '720px !important',
        'div:nth-of-type(1)': {
          lineHeight: '28px',
          paddingBottom: '8px',
        },
        '> div': {
          marginTop: '1rem',
        },
      })}
    >
      <Alert>
        <Trans
          i18nKey={i18nKey}
          components={{
            linkElement: <StyledSpan onClick={onClick} />,
          }}
        />
      </Alert>
    </Box>
  );
};

export default LearnerSearchMessage;
